import * as React from 'react';

const Percent = (props:any) => (
    <svg width={24} height={24} viewBox="0 0 24 24" {...props}>
        <path d="M16.412 17.643c.742 0 1.23-.723 1.23-1.866 0-1.162-.468-1.865-1.23-1.865s-1.24.723-1.24 1.865c0 1.143.478 1.866 1.24 1.866zm0 1.65c-1.894 0-3.193-1.426-3.193-3.516 0-2.08 1.299-3.506 3.193-3.506 1.895 0 3.184 1.426 3.184 3.506 0 2.09-1.29 3.516-3.184 3.516zm-8.525-7.656c-1.895 0-3.203-1.436-3.203-3.516s1.308-3.506 3.203-3.506c1.894 0 3.183 1.416 3.183 3.506 0 2.08-1.289 3.516-3.183 3.516zM8.463 19H6.06l5.341-7.363 4.493-6.729h2.392l-5.43 7.461L8.463 19zm-.576-9.014c.742 0 1.23-.732 1.23-1.875 0-1.162-.469-1.855-1.23-1.855-.762 0-1.24.713-1.24 1.855 0 1.143.478 1.875 1.24 1.875z" />
    </svg>
);

export default Percent;

